<template>
  <section class="box topics display-pc">
    <div class="container">
      <com-h1 :title="$store.state.isPastHot === 1 ? '往届热门专题' : '热门专题'"></com-h1>
      <hot-topic :topics="hotTopics" :lectures="lectures"></hot-topic>
    </div>
  </section>
</template>
<script>
import comH1 from 'gkConUI/com-h1'
import hotTopic from 'gkConUI/com-topics/topics2'

export default {
  data () {
    return {}
  },
  components: {
    comH1,
    hotTopic
  },
  props: ['hotTopics', 'lectures'],
  computed: {}
}
</script>
<style scoped lang='sass'>

.topics
  padding: 47px 0
</style>
